import styled from 'styled-components';
import { Modal } from 'lib/components/Modal/Modal';

export const StyledDeleteNoteModal = styled(Modal)`
  .modal__description {
    ${(props): string => props.theme.mixins.truncateText}
  }
`;
